<template>
	<div class="p-grid">
		<div class="p-col-12">
			<div class="card p-shadow-1">
				<h5>Clientes</h5>
                <hr>
				<Toolbar class="p-mb-4">
					<template slot="left">						
						<Button type="button" icon="pi pi-plus" label="Novo" class="p-mr-2" @click="novo" v-if="permissaoNovo"/>												
					</template>
				</Toolbar>
				<DataTable :value="empresas"  :autoLayout="true"  :filters="filtro" :paginator="true" :rows="10"
					paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
					:rowsPerPageOptions="[10,15,20]" currentPageReportTemplate="Listando {first} a {last} de {totalRecords}"
					class="p-datatable-sm p-datatable-striped">		
					<Column field="id" header="Id" sortable></Column>			
					<Column field="nome" header="Nome" sortable></Column>
					<Column field="cnpj" header="CNPJ" sortable></Column>				
					<Column field="seguimento" header="Seguimento" sortable></Column>
					<Column field="dataCadastro" header="Cadastro" sortable></Column>					
					<Column field="status" header="Status" sortable>
						<template #body="slotProps">                                    
							<div>   							                                     
								<span class="p-badge p-badge-lg p-badge-danger" title="Cliente Bloqueado" v-if="slotProps.data.status == 2" >
									<i style="color:#F9B720" class="pi pi-lock" ></i>                                       
								</span>
								<span class="p-badge p-badge-lg p-badge-secondary" title="Cliente Inativo" v-else-if="slotProps.data.status == 0" >
									<i class="pi pi-power-off" ></i>                                       
								</span>
								<span class="p-badge p-badge-lg p-badge-success" title="Cliente Ativo" v-else>                                          
									<i class="pi pi-lock-open"></i>
								</span>                                        
							</div>
						</template>
					</Column>					
					<Column  header="Editar">
						<template #body="slotProps">
							<Button icon="pi pi-pencil" title="Editar" class="p-button-rounded p-button-primary p-mr-2" @click="editar(slotProps.data)" v-if="permissaoEditar"/>							
						</template>
					</Column>
				</DataTable>						

			</div>
		</div>
	</div>
</template>

<script>
import RevendedorService from '@/service/RevendedorService';
import Cnpj from '@/model/Cnpj';
import { exibirMensagem } from '@/global';
import { mapGetters } from 'vuex';

export default {
	revendedorService: null,
	data() {
		return {
			permissaoNovo: false,
			permissaoEditar: false,			
			exibirDialogCadastro: false,		
			enviandoForm: false,	
			cnpj: new Cnpj(),	
			cnpjs: [],		
			diasInicio: [],
			diasFinal: [],
			empresa: {},
            empresas: [],
			filtro: {}
		}
	},
	methods: {
		...mapGetters('sessao', ['getDadosRequisicao','getPermissoes', 'getUsuario']),	
		listar(){
			let requisicao = {                   
                usuarioRequisicao: {...this.getDadosRequisicao()},
				idRevendedor: this.getUsuario().id,
            };			
			this.revendedorService.listarClientes(requisicao)
				.then(resp => {			
					this.empresas = resp.data;						
                })
                .catch(erro => {exibirMensagem(this, erro)});
		},
		novo() {
			this.$router.push('/cadastro/clientes/novo');
		},
		editar(empresa) {
			this.$router.push('/cadastro/clientes/'+empresa.id+'/editar');
		},
		validarPermissoes() {		
			let permissoes = this.getPermissoes();
			this.permissaoNovo = permissoes.includes(99999);
			this.permissaoEditar = permissoes.includes(99999);				
		}
	},	
	created() {
		this.revendedorService = new RevendedorService();		
	},
	mounted() {	
		this.validarPermissoes();	
		this.listar();		
	}
}
</script>

<style scoped>
</style>